import { render } from "./PurchaseComponent.vue?vue&type=template&id=51c8e94e"
import script from "./PurchaseComponent.vue?vue&type=script&lang=js"
export * from "./PurchaseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/purchase/PurchaseComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51c8e94e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51c8e94e', __exports__)) {
    api.reload('51c8e94e', __exports__)
  }
  
  module.hot.accept("./PurchaseComponent.vue?vue&type=template&id=51c8e94e", () => {
    api.rerender('51c8e94e', render)
  })

}


export default __exports__